import React, { PureComponent } from 'react'
import SearchBar from '@argos/search-bar'

import './StoreLocator.scss'

class StoreLocator extends PureComponent {
  searchForStores (input) {
    if (input && !/^\s*$/.test(input)) {
      document.activeElement.blur()
      window.location.href = '//www.argos.co.uk/stores/search/' + encodeURI(input)
    }
  }

  render () {
    return (
      <div className='store-locator'>
        <div className='store-locator__panel store-popout'>
          <h2 className='store-locator__title h2'>Find a store near you</h2>
          <p className='store-locator__text font-bold'>Postcode or town</p>
          <p className='store-locator__text font-standard'>(for stores in Northern Ireland enter a postcode)</p>
          <div className='store-locator__form'>
            <SearchBar hasIcon={false} cta='See Stores' placeholder='My town or postcode is...' onSubmit={this.searchForStores} />
          </div>
          <p><a href='https://www.argos.ie/webapp/wcs/stores/servlet/ArgosStoreLocatorDB?includeName=StoreLocator&langId=111&storeId=10152' className='button-link button-link--roi-stores'>View stores in the Republic of Ireland</a></p>
        </div>
      </div>
    )
  }
}

export default StoreLocator
